<template>
<div
    :class="{
        'VehicleState': 1,
        'VehicleState--variantCompatibilityChecker': variant == 'compatibility-checker',
        'VehicleState--variantHeaderOverlap': variant == 'header-overlap',
        'VehicleState--variantProductOverlay': variant == 'product-overlay',
    }">
    <transition name="VehicleState_fade" mode="out-in">
        <vehicle-state-vehicle
            v-if="vehicle"
            :productId="this.productId"
            :variant="variant"/>
        <vehicle-state-empty
            v-else
            :variant="variant"/>
    </transition>
</div>
</template>

<script>
import { components as partindexComponents } from '@scripts/services/partindex'
import { garageService } from '@scripts/services/garageService'

import VehicleStateEmpty from './VehicleStateEmpty'
import VehicleStateVehicle from './VehicleStateVehicle'

export default {
    props: {
        variant: String,
        productId: Number
    },
    data () {
        return {

        }
    },
    computed: {
        vehicle () {
            if (garageService.activeVehicle == null) return null

            if (this.variant === 'service' && !('vin' in garageService.activeVehicle)) {
                return null
            }

            return garageService.activeVehicle
        }
    },
    components: {
        ...partindexComponents,
        VehicleStateEmpty,
        VehicleStateVehicle
    },
    mounted: function () {
        console.log('VehicleLookupBar', this)
    }
}
</script>

<style lang="scss">
$fontRegular: 'Ford Antenna', Helvetica, Arial, sans-serif;
$fontCondensed: 'Ford Antenna Condensed', 'Ford Antenna Cond', Helvetica, Arial, sans-serif;

$mobileBreakpoint: 768px;
$smallDesktopBreakpoint: 1024px;

.VehicleState {
    margin-bottom: 45px;

    &_fade {
        &-enter-active,
        &-leave-active {
            opacity: 1;
            transform: translateY(0);
            transition: opacity 0.1s ease-in, transform 0.1s ease-in;
        }

        &-enter,
        &-leave-to {
            opacity: 0;
            transform: translateY(20px);
        }
    }

    @media screen and (max-width: $mobileBreakpoint) {
        margin-bottom: 10px;
    }

    &--variantProductOverlay {
        margin-bottom: 0;

        @media screen and (min-width: $mobileBreakpoint) {
            padding-right: 30px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// VehicleState.vue?61d0784e